import React from 'react';
import styled from 'styled-components';
import { Case, Site } from '../../../services/buildfire/rdb/cases';
import Typography from '../../common/Typography';
import SiteListItem from './SiteListItem';
import SiteFormDialog from './SiteFormDialog';

interface SitesListProps {
  case: Case;
  sites: Site[];
  userId: string;
  showTitle?: boolean;
  isEditable?: boolean;
  isDeleteable?: boolean;
  onEdited?: (site: Site, siteIndex: number) => Promise<{ hasFailures: boolean; site?: Site } | void>;
  onDeleted?: (site: Site, siteIndex: number) => void;
}

const List = styled.ul`
  padding: 0;
  list-styled-type: none;
  // margin-bottom: 100px;
`;
const SitesTitle = styled(Typography)`
  margin: 8px 16px 4px 16px;
`;

const SitesList: React.FC<SitesListProps> = ({
  case: c,
  sites,
  userId,
  showTitle = true,
  isEditable = false,
  isDeleteable = false,
  onDeleted,
  onEdited,
}) => {
  const [siteFormDialogIndex, setSiteFormDialogIndex] =
    React.useState<number>();
  const isSiteFormDialogOpen = siteFormDialogIndex !== undefined;

  return (
    <>
      {showTitle && (
        <SitesTitle variant="secondary" fontSize="16px" fontWeight="600">
          Sites
        </SitesTitle>
      )}
      <List>
        {sites.map((s, i) => (
          <SiteListItem
            key={`${s.location}-${i}`}
            case={c}
            site={s}
            userId={userId}
            siteIndex={i}
            onEdit={(s, e) => {
              e?.stopPropagation();
              setSiteFormDialogIndex(i);
            }}
            onDelete={(s, e) => {
              onDeleted?.(s, i);
            }}
            isEditable={isEditable}
            isDeleteable={isDeleteable}
          />
        ))}
      </List>

      <SiteFormDialog
        isOpen={isSiteFormDialogOpen}
        SiteFormProps={{
          initialValue: sites[siteFormDialogIndex as any],
          onSubmit: async (site, resetForm, setFieldValue) => {
            const result = await onEdited?.(site, siteFormDialogIndex!);

            // Only close modal if upload was successful
            if (result && !result.hasFailures) {
              resetForm?.(); // Reset Formik dirty state
              setSiteFormDialogIndex(undefined);
            } else if (result && result.site) {
              // Update form with new images that show correct upload status
              setFieldValue?.('images', result.site.images);
            }
            // If hasFailures, modal stays open showing retry UI
          },
        }}
        onClose={() => setSiteFormDialogIndex(undefined)}
      />
    </>
  );
};

export default SitesList;
